import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56ce5424"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-switch" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "39",
  height: "39",
  viewBox: "0 0 39 39"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("linearGradient", {
      id: "linear-gradient",
      x1: "0.5",
      y1: "1",
      x2: "0.5",
      gradientUnits: "objectBoundingBox"
    }, [
      /*#__PURE__*/_createElementVNode("stop", {
        offset: "0",
        "stop-color": "#fec381"
      }),
      /*#__PURE__*/_createElementVNode("stop", {
        offset: "1",
        "stop-color": "#ffdbb4"
      })
    ]),
    /*#__PURE__*/_createElementVNode("filter", {
      id: "Ellipse_61",
      x: "0",
      y: "0",
      width: "39",
      height: "39",
      filterUnits: "userSpaceOnUse"
    }, [
      /*#__PURE__*/_createElementVNode("feOffset", {
        dy: "3",
        input: "SourceAlpha"
      }),
      /*#__PURE__*/_createElementVNode("feGaussianBlur", {
        stdDeviation: "1.5",
        result: "blur"
      }),
      /*#__PURE__*/_createElementVNode("feFlood", { "flood-opacity": "0.2" }),
      /*#__PURE__*/_createElementVNode("feComposite", {
        operator: "in",
        in2: "blur"
      }),
      /*#__PURE__*/_createElementVNode("feComposite", { in: "SourceGraphic" })
    ]),
    /*#__PURE__*/_createElementVNode("linearGradient", {
      id: "linear-gradient-2",
      x1: "0.5",
      x2: "0.5",
      y2: "1",
      gradientUnits: "objectBoundingBox"
    }, [
      /*#__PURE__*/_createElementVNode("stop", {
        offset: "0",
        "stop-color": "#fab86c"
      }),
      /*#__PURE__*/_createElementVNode("stop", {
        offset: "1",
        "stop-color": "#ffedd9"
      }),
      /*#__PURE__*/_createElementVNode("stop", {
        offset: "1",
        "stop-color": "#fad9b4"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("g", {
    id: "but_settting_volume",
    transform: "translate(4.5 1.5)"
  }, [
    /*#__PURE__*/_createElementVNode("g", { id: "button" }, [
      /*#__PURE__*/_createElementVNode("g", {
        transform: "matrix(1, 0, 0, 1, -4.5, -1.5)",
        filter: "url(#Ellipse_61)"
      }, [
        /*#__PURE__*/_createElementVNode("circle", {
          id: "Ellipse_61-2",
          "data-name": "Ellipse 61",
          cx: "15",
          cy: "15",
          r: "15",
          transform: "translate(4.5 1.5)",
          fill: "url(#linear-gradient)"
        })
      ]),
      /*#__PURE__*/_createElementVNode("circle", {
        id: "Ellipse_62",
        "data-name": "Ellipse 62",
        cx: "12",
        cy: "12",
        r: "12",
        transform: "translate(3 3)",
        fill: "url(#linear-gradient-2)"
      })
    ])
  ])
], -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: _ctx.value,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitEvent($event)))
    }, null, 40, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["track", { active: _ctx.value }])
    }, _hoisted_4, 2)
  ]))
}